export default __webpack_public_path__ + "static/media/chromeicon.e05eda7f.png";